import { connect, FormikContextType, getIn } from 'formik';
import React, { useMemo } from 'react';
import { VERTICAL_SEPARATOR } from '~/Constants/Colors.constants';
import { GoogleMap } from '~/UIKit';
import { ExtendedLocation } from '../../ExtendedLocation.model';
import { defaultLatLong } from '~/Constants/Values.constants';

export const LocationEditCustomGoogleMap = connect<{}, ExtendedLocation>(
  ({ formik }: { formik: FormikContextType<ExtendedLocation> }) => {
    if (!formik) {
      return null;
    }
    const latitude: number = getIn(formik.values, 'latitude', defaultLatLong.lat);
    const longitude: number = getIn(formik.values, 'longitude', defaultLatLong.lng);
    const position = useMemo(() => {
      if (latitude && longitude) {
        return {
          lat: latitude,
          lng: longitude,
        };
      }
      return defaultLatLong;
    }, [latitude, longitude]);

    const handleOnMapUpdate = ({
      latitude,
      longitude,
    }: {
      latitude: number;
      longitude: number;
    }) => {
      const fixedLatitude = Number(Number(latitude).toFixed(7));
      const fixedLongitude = Number(Number(longitude).toFixed(7));
      formik.setValues((prevValues) => ({
        ...prevValues,
        latitudeMap: fixedLatitude,
        longitudeMap: fixedLongitude,
      }));
    };

    return (
      <GoogleMap
        containerStyle={{
          height: 285,
          width: '100%',
          display: 'block',
          borderTop: `1px solid ${VERTICAL_SEPARATOR}`,
          borderBottom: `1px solid ${VERTICAL_SEPARATOR}`,
        }}
        position={position}
        defaultZoom={15}
        options={{
          mapTypeControl: false,
          fullscreenControl: false,
          zoomControl: false,
          gestureHandling: 'cooperative',
        }}
        onMapUpdate={handleOnMapUpdate}
      />
    );
  },
);
